<template>
  <div ref="baseRoot" class="p-base-root">
    <template v-if="type=='preview'">
      <div v-for="(item,index) in modules" :key="index" @click.capture.stop>
        <m-swiper-search
          v-if="item.code=='swiper-search'"
          :params="item.params"
          :data="item.data"
          :pattern="item.style"
        />
        <m-swiper
          v-if="item.code=='swiper'"
          :params="item.params"
          :data="item.data"
          :pattern="item.style"
        />
        <m-search
          v-if="item.code=='search'"
          :params="item.params"
          :data="item.data"
          :pattern="item.style"
        />
        <m-box-product
          v-if="item.code=='box' || item.code=='box-product'"
          :params="item.params"
          :data="item.data"
          :pattern="item.style"
          :type="type"
        />
        <m-img-one
          v-if="item.code=='img-one'"
          :params="item.params"
          :data="item.data"
          :pattern="item.style"
        />
        <m-img-two
          v-if="item.code=='img-two'"
          :params="item.params"
          :data="item.data"
          :pattern="item.style"
        />
        <m-img-more
          v-if="item.code=='img-more'"
          :params="item.params"
          :data="item.data"
          :pattern="item.style"
        />
        <m-tre-one
          v-if="item.code=='tre-one'"
          :params="item.params"
          :data="item.data"
          :pattern="item.style"
          :type="type"
        />
        <m-tre-two
          v-if="item.code=='tre-two'"
          :params="item.params"
          :data="item.data"
          :pattern="item.style"
          :type="type"
        />
        <m-tre-more
          v-if="item.code=='tre-more'"
          :params="item.params"
          :data="item.data"
          :pattern="item.style"
          :type="type"
        />
        <m-nav
          v-if="item.code=='nav'"
          :params="item.params"
          :data="item.data"
          :pattern="item.style"
        />
        <m-friend
          v-if="item.code=='friend'"
          :params="item.params"
          :data="item.data"
          :pattern="item.style"
        />
        <m-header
          v-if="item.code=='header'"
          :params="item.params"
          :data="item.data"
          :pattern="item.style"
        />
        <m-open
          v-if="item.code=='open'"
          :params="item.params"
          :data="item.data"
          :pattern="item.style"
        />
        <m-video
          v-if="item.code=='video'"
          :params="item.params"
          :data="item.data"
          :pattern="item.style"
        />
        <m-swiper-card
          v-if="item.code=='swiper-card'"
          :params="item.params"
          :data="item.data"
          :pattern="item.style"
        />
        <m-swiper-card2
          v-if="item.code=='swiper-card2'"
          :params="item.params"
          :data="item.data"
          :pattern="item.style"
        />
        <m-recommend
          v-if="item.code=='recommend'"
          :params="item.params"
          :data="item.data"
          :pattern="item.style"
        />
        <m-swiper-lrregular
          v-if="item.code=='swiper-lrregular'"
          :params="item.params"
          :data="item.data"
          :pattern="item.style"
        />
        <m-img-text
          v-if="item.code=='img-text'"
          :params="item.params"
          :data="item.data"
          :pattern="item.style"
        />
      </div>
    </template>

    <template v-if="type=='default'">
      <div v-for="(item,index) in modules" :key="index">
        <m-swiper-search
          v-if="item.code=='swiper-search'"
          :params="item.params"
          :data="item.data"
          :pattern="item.style"
        />
        <m-swiper
          v-if="item.code=='swiper'"
          :params="item.params"
          :data="item.data"
          :pattern="item.style"
        />
        <m-search
          v-if="item.code=='search'"
          :params="item.params"
          :data="item.data"
          :pattern="item.style"
        />
        <m-box-product
          ref="boxproduct"
          v-if="item.code=='box' || item.code=='box-product'"
          :params="item.params"
          :data="item.data"
          :pattern="item.style"
          :type="type"
        />
        <m-img-one
          v-if="item.code=='img-one'"
          :params="item.params"
          :data="item.data"
          :pattern="item.style"
        />
        <m-img-two
          v-if="item.code=='img-two'"
          :params="item.params"
          :data="item.data"
          :pattern="item.style"
        />
        <m-img-more
          v-if="item.code=='img-more'"
          :params="item.params"
          :data="item.data"
          :pattern="item.style"
        />
        <m-tre-one
          ref="tremone"
          v-if="item.code=='tre-one'"
          :params="item.params"
          :data="item.data"
          :pattern="item.style"
          :type="type"
        />
        <m-tre-two
          ref="tretwo"
          v-if="item.code=='tre-two'"
          :params="item.params"
          :data="item.data"
          :pattern="item.style"
          :type="type"
        />
        <m-tre-more
          ref="tremore"
          v-if="item.code=='tre-more'"
          :params="item.params"
          :data="item.data"
          :pattern="item.style"
          :type="type"
        />
        <m-nav
          v-if="item.code=='nav'"
          :params="item.params"
          :data="item.data"
          :pattern="item.style"
        />
        <m-friend
          v-if="item.code=='friend'"
          :params="item.params"
          :data="item.data"
          :pattern="item.style"
        />
        <m-header
          v-if="item.code=='header'"
          :params="item.params"
          :data="item.data"
          :pattern="item.style"
        />
        <m-open
          v-if="item.code=='open'"
          :params="item.params"
          :data="item.data"
          :pattern="item.style"
        />
        <m-video
          v-if="item.code=='video'"
          :params="item.params"
          :data="item.data"
          :pattern="item.style"
        />
        <m-swiper-card
          v-if="item.code=='swiper-card'"
          :params="item.params"
          :data="item.data"
          :pattern="item.style"
        />
        <m-swiper-card2
          v-if="item.code=='swiper-card2'"
          :params="item.params"
          :data="item.data"
          :pattern="item.style"
        />
        <m-recommend
          v-if="item.code=='recommend'"
          :params="item.params"
          :data="item.data"
          :pattern="item.style"
        />

        <m-swiper-lrregular
          v-if="item.code=='swiper-lrregular'"
          :params="item.params"
          :data="item.data"
          :pattern="item.style"
        />
        <m-img-text
          v-if="item.code=='img-text'"
          :params="item.params"
          :data="item.data"
          :pattern="item.style"
        />
      </div>
    </template>

    <template v-if="type=='edit'">
      <draggable
        :options="{animation:380}"
        v-model="myModules"
        @change="change"
        @start="start"
        @end="end"
        :move="move"
      >
        <div
          class="module"
          style="position: relative;"
          v-for="(item,index) in myModules"
          :key="index"
          @click.capture.stop="editModule($event,item,index)"
        >
          <m-swiper-search
            v-if="item.code=='swiper-search'"
            :params="item.params"
            :data="item.data"
            :pattern="item.style"
          />
          <m-swiper
            v-if="item.code=='swiper'"
            :params="item.params"
            :data="item.data"
            :pattern="item.style"
          />
          <m-search
            v-if="item.code=='search'"
            :params="item.params"
            :data="item.data"
            :pattern="item.style"
          />
          <m-box-product
            v-if="item.code=='box' || item.code=='box-product'"
            :params="item.params"
            :data="item.data"
            :pattern="item.style"
            :type="type"
          />
          <m-img-one
            v-if="item.code=='img-one'"
            :params="item.params"
            :data="item.data"
            :pattern="item.style"
          />
          <m-img-two
            v-if="item.code=='img-two'"
            :params="item.params"
            :data="item.data"
            :pattern="item.style"
          />
          <m-img-more
            v-if="item.code=='img-more'"
            :params="item.params"
            :data="item.data"
            :pattern="item.style"
          />
          <m-tre-one
            v-if="item.code=='tre-one'"
            :params="item.params"
            :data="item.data"
            :pattern="item.style"
            :type="type"
          />
          <m-tre-two
            v-if="item.code=='tre-two'"
            :params="item.params"
            :data="item.data"
            :pattern="item.style"
            :type="type"
          />
          <m-tre-more
            v-if="item.code=='tre-more'"
            :params="item.params"
            :data="item.data"
            :pattern="item.style"
            :type="type"
          />
          <m-nav
            v-if="item.code=='nav'"
            :params="item.params"
            :data="item.data"
            :pattern="item.style"
          />
          <m-friend
            v-if="item.code=='friend'"
            :params="item.params"
            :data="item.data"
            :pattern="item.style"
          />
          <m-header
            v-if="item.code=='header'"
            :params="item.params"
            :data="item.data"
            :pattern="item.style"
          />
          <m-open
            v-if="item.code=='open'"
            :params="item.params"
            :data="item.data"
            :pattern="item.style"
          />
          <m-video
            v-if="item.code=='video'"
            :params="item.params"
            :data="item.data"
            :pattern="item.style"
          />
          <m-swiper-card
            v-if="item.code=='swiper-card'"
            :params="item.params"
            :data="item.data"
            :pattern="item.style"
          />
          <m-swiper-card2
            v-if="item.code=='swiper-card2'"
            :params="item.params"
            :data="item.data"
            :pattern="item.style"
          />
          <m-recommend
            v-if="item.code=='recommend'"
            :params="item.params"
            :data="item.data"
            :pattern="item.style"
          />

          <m-swiper-lrregular
            v-if="item.code=='swiper-lrregular'"
            :params="item.params"
            :data="item.data"
            :pattern="item.style"
          />
          <m-img-text
            v-if="item.code=='img-text'"
            :params="item.params"
            :data="item.data"
            :pattern="item.style"
          />
          <div v-if="currentIndex==index" class="selected"></div>
        </div>
      </draggable>
    </template>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
export default {
  components: {
    draggable
  },
  model: {
    prop: 'modules',
    event: 'changeModules'
  },
  props: {
    type: {
      type: String,
      default: 'default'
    },
    currentIndex: {
      type: Number,
      default: -1
    },
    modules: {
      type: Array,
      default: () => [{
        code: 'swiper-search',
        sort: 0,
        params: {
          placeholder: '请输入关键字搜索'
        },
        data: [{
          src: "/static/temp/banner3.jpg",
          navTo: 'https://www.baidu.com'
        }, {
          src: "/static/temp/banner2.jpg",
          navTo: 'https://www.baidu.com'
        }, {
          src: "/static/temp/banner4.jpg",
          navTo: '/pages/product/product?id=1'
        }],
        style: {
          showBottomBorder: false
        },
      },
      {
        code: 'search',
        sort: 1,
        params: {
          placeholder: '请输入关键字搜索'
        },
        data: [],
        style: {
          showBottomBorder: true
        },
      },

      {
        code: 'nav',
        sort: 2,
        params: {},
        data: [],
        style: {
          showBottomBorder: true,
          showBorderRadius: false,
          boxType: 'block',
          circle: true
        },
      },
      {
        code: 'swiper',
        sort: 3,
        params: {},
        data: [{
          src: "/static/temp/banner3.jpg",
          navTo: 'https://www.baidu.com'
        }, {
          src: "/static/temp/banner2.jpg",
          navTo: 'https://www.baidu.com'
        }, {
          src: "/static/temp/banner4.jpg",
          navTo: '/pages/product/product?id=1'
        }],
        style: {
          showBottomBorder: true
        },
      },
      {
        code: 'box-product',
        sort: 4,
        params: {
          title: '热销商品',
          subTitle: 'Hot Sales',
          showMore: true,
          icon: '/static/temp/h1.png'
        },
        data: {
          type: 'product',
          list: []
        },
        style: {
          boxType: 'block',
          showBottomBorder: true,
          showHeader: true,
          showBorderRadius: false,
          layoutType: '1row2column'
        },
      },
      {
        code: 'img-one',
        sort: 5,
        params: {},
        data: {
          src: 'http://images.jaadee.com/images/201702/goods_img/30150_d85aed83521.jpg',
          navTo: '/pages/product/product?id=1'
        },
        style: {
          boxType: 'block',
          showBottomBorder: true,
          showPadding: true,
          showBorderRadius: false,
        },
      },
      {
        code: 'img-two',
        sort: 6,
        params: {},
        data: [{
          src: 'http://images.jaadee.com/images/201702/goods_img/30150_d85aed83521.jpg',
          navTo: '/pages/product/product?id=1'
        }, {
          src: 'http://images.jaadee.com/images/201702/goods_img/30150_d85aed83521.jpg',
          navTo: '/pages/product/product?id=1'
        }],
        style: {
          boxType: 'block',
          showBottomBorder: true,
          showPadding: true,
          showBorderRadius: false,
        },
      },
      {
        code: 'img-more',
        sort: 7,
        params: {},
        data: [{
          src: 'http://images.jaadee.com/images/201702/goods_img/30150_d85aed83521.jpg',
          navTo: '/pages/product/product?id=1'
        }, {
          src: 'http://images.jaadee.com/images/201702/goods_img/30150_d85aed83521.jpg',
          navTo: '/pages/product/product?id=1'
        }, {
          src: 'http://images.jaadee.com/images/201702/goods_img/30150_d85aed83521.jpg',
          navTo: '/pages/product/product?id=1'
        }, {
          src: 'http://images.jaadee.com/images/201702/goods_img/30150_d85aed83521.jpg',
          navTo: '/pages/product/product?id=1'
        }, {
          src: 'http://images.jaadee.com/images/201702/goods_img/30150_d85aed83521.jpg',
          navTo: '/pages/product/product?id=1'
        }],
        style: {
          boxType: 'block',
          showBottomBorder: true,
          showPadding: true,
          showBorderRadius: false,
        },
      },
      {
        code: 'tre-one',
        sort: 8,
        params: {},
        data: {
          type: 'product',
          data: {
            id: 2,
            picture: "http://pic.rmb.bdstatic.com/819a044daa66718c2c40a48c1ba971e6.jpeg",
            name: "古黛妃 短袖t恤女夏装2019新款韩版宽松",
            subName: '夏装2019新款韩版宽松',
            price: 688,
            scanNum: 10000,
          },

        },
        style: {
          boxType: 'block',
          showBottomBorder: true,
          showPadding: true,
          showBorderRadius: false,
        },
      },
      {
        code: 'tre-two',
        sort: 9,
        params: {},
        data: {
          type: 'product',
          list: [{
            id: 1,
            picture: "http://pic.rmb.bdstatic.com/819a044daa66718c2c40a48c1ba971e6.jpeg",
            name: "古黛妃 短袖t恤女夏装2019新款韩版宽松",
            subName: '夏装2019新款韩版宽松',
            price: 688,
            scanNum: 10000,
          },
          {
            id: 2,
            picture: "http://pic.rmb.bdstatic.com/819a044daa66718c2c40a48c1ba971e6.jpeg",
            name: "古黛妃 短袖t恤女夏装2019新款韩版宽松",
            subName: '夏装2019新款韩版宽松',
            price: 688,
            scanNum: 10000,
          },
          ]
        },
        style: {
          boxType: 'block',
          showBottomBorder: true,
          showPadding: true,
          showBorderRadius: false,
        },
      },
      {
        code: 'tre-more',
        sort: 10,
        params: {},
        data: {
          type: 'product',
          list: [{
            id: 1,
            picture: "http://pic.rmb.bdstatic.com/819a044daa66718c2c40a48c1ba971e6.jpeg",
            name: "古黛妃 短袖t恤女夏装2019新款韩版宽松",
            subName: '夏装2019新款韩版宽松',
            price: 688,
            scanNum: 10000,
          },
          {
            id: 2,
            picture: "http://pic.rmb.bdstatic.com/819a044daa66718c2c40a48c1ba971e6.jpeg",
            name: "古黛妃 短袖t恤女夏装2019新款韩版宽松",
            subName: '夏装2019新款韩版宽松',
            price: 688,
            scanNum: 10000,
          },
          {
            id: 1,
            picture: "http://pic.rmb.bdstatic.com/819a044daa66718c2c40a48c1ba971e6.jpeg",
            name: "古黛妃 短袖t恤女夏装2019新款韩版宽松",
            subName: '夏装2019新款韩版宽松',
            price: 688,
            scanNum: 10000,
          },
          {
            id: 2,
            picture: "http://pic.rmb.bdstatic.com/819a044daa66718c2c40a48c1ba971e6.jpeg",
            name: "古黛妃 短袖t恤女夏装2019新款韩版宽松",
            subName: '夏装2019新款韩版宽松',
            price: 688,
            scanNum: 10000,
          }
          ]
        },
        style: {
          boxType: 'block',
          showBottomBorder: true,
          showPadding: true,
          showBorderRadius: false,
        },
      },
      {
        code: 'friend',
        sort: 11,
        params: {
          title: '友情链接'
        },
        data: [
          {
            src: "http://pic.rmb.bdstatic.com/819a044daa66718c2c40a48c1ba971e6.jpeg",
            navTo: "",
          },
          {
            src: "http://pic.rmb.bdstatic.com/819a044daa66718c2c40a48c1ba971e6.jpeg",
            navTo: "",
          },
          {
            src: "http://pic.rmb.bdstatic.com/819a044daa66718c2c40a48c1ba971e6.jpeg",
            navTo: "",
          },
          {
            src: "http://pic.rmb.bdstatic.com/819a044daa66718c2c40a48c1ba971e6.jpeg",
            navTo: "",
          }
        ],
        style: {
          showBottomBorder: true,
          showBorderRadius: false,
          boxType: 'block',
          imageBorderRadius: true
        },
      },
      ]
    }
  },
  data () {
    return {
      myCurrentIndex: this.currentIndex,
      myModules: []
    }
  },
  methods: {
    //evt里面有两个值，一个evt.added 和evt.removed  可以分别知道移动元素的ID和删除元素的ID
    change (evt) {
      // console.log(evt)
    },
    //start ,end ,add,update, sort, remove 得到的都差不多
    start (evt) {
      // console.log(evt)
    },
    end (evt) {
      this.$emit('updateModules', this.myModules)
      if (evt.oldIndex == this.myCurrentIndex) {
        this.myCurrentIndex = evt.newIndex
      } else if (evt.newIndex == this.myCurrentIndex) {
        this.myCurrentIndex = evt.oldIndex
      }
      let that = this
      that.$nextTick(() => {
        if (that.myCurrentIndex != -1) {
          let event = document.getElementsByClassName('module')[that.myCurrentIndex]
          let top = event.getBoundingClientRect().top
          let item = that.modules[that.myCurrentIndex]
          that.$emit('clickItem', top, item, that.myCurrentIndex)
        }
      })
      // evt.item //可以知道拖动的本身
      // evt.to    // 可以知道拖动的目标列表
      // evt.from  // 可以知道之前的列表
      // evt.oldIndex  // 可以知道拖动前的位置
      // evt.newIndex  // 可以知道拖动后的位置
    },
    move (evt, originalEvent) {
      // console.log(evt)
      // console.log(originalEvent) //鼠标位置
    },


    editModule (event, item, index) {
      console.log(item, index)
      let msg = {
        item, index
      }
      var DOM = event.currentTarget;
      // 获取节点距离浏览器视口的高度
      var top = event.currentTarget.getBoundingClientRect().top;
      this.$emit('clickItem', top, item, index)
      this.myCurrentIndex = index
    },
    loadData () {
      // for (let refName in this.$refs) {
      //   let refs = this.$refs[refName]
      //   for (let ref of refs) {
      //     if (ref.refreshData) {
      //       console.log('ref.refreshData')
      //       ref.refreshData()
      //     }
      //   }
      // }
    }
  },
  watch: {
    myModules: {
      deep: true,
      handler: function (newVal) {
        this.$emit('changeModules', newVal)
        let that = this
        const updateTops = function () {
          let children = document.getElementsByClassName('module')
          if (children) {
            let tops = []
            for (let child of children) {
              tops.push(child.getBoundingClientRect().top)
            }
            that.$emit('updateTops', tops)
          }
        }
        that.$nextTick(() => {
          updateTops()
          setTimeout(() => {
            updateTops()
          }, 300)
        })
      }
    },
    currentIndex (val) {
      if (this.myCurrentIndex != val) {
        this.myCurrentIndex = val
        let that = this
        that.$nextTick(() => {
          if (that.myCurrentIndex != -1) {
            console.log('shouji  that.myCurrentIndex', val)
            let event = document.getElementsByClassName('module')[that.myCurrentIndex]
            if (event) {
              let top = event.getBoundingClientRect().top
              let item = that.modules[that.myCurrentIndex]
              that.$emit('clickItem', top, item, that.myCurrentIndex)
            }
          }
        })
      }
    },
    modules: {
      handler: function (newVal) {
        this.myModules = newVal

      },
    }
  }
}
</script>

<style lang="scss" scoped>
.p-base-root {
  background-color: rgb(248, 248, 248);
}
.selected {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  border: 2px dotted #409eff;
}
</style>
